import React, {
  FC, useCallback, useEffect, useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from 'react-toastify';
import { budgetAcceptConfirmModalComponent } from './types';
import Modal from 'components/base/Modal';

import { RecordInfoDto } from 'config/apiFunus/record/types';
import { useRecord } from 'hooks/useRecord';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { showInfoToast } from 'utils/toasts';

export const BudgetAcceptConfirmModal: FC<budgetAcceptConfirmModalComponent> = (
  {
    show, onCancel, onSuccess, budgetId, erpId,
  },
) => {
  const { t } = useTranslation();
  const { AcceptBudget, actionOnCourse } = useBudget();
  const { getInfo } = useRecord();
  const [recordInfo, setRecordInfo] = useState<RecordInfoDto>();

  useEffect(() => {
    if (erpId && show) {
      getInfo(erpId)
        .then((info) => setRecordInfo(info))
        .catch(() => false);
    }
  }, [erpId, getInfo, show]);

  const handleAccept = useCallback(() => {
    AcceptBudget(budgetId)
      .then((response) => {
        if (recordInfo?.articleCode) {
          showInfoToast(t('budget.flowerGiftInfo', {
            articleDescription: recordInfo?.articleDescription,
            expedient: erpId,
            location: recordInfo?.deathLocationDescription,
          }), {
            autoClose: false,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        onSuccess();
        return response;
      })
      .catch(() => false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    budgetId,
    erpId,
    recordInfo?.articleCode,
    recordInfo?.articleDescription, recordInfo?.deathLocationDescription, t]);

  return (
    <Modal
      buttons={[
        {
          color: 'secondary',
          onClick: () => {
            onCancel();
          },
          text: t('common.cancel'),
        },
        {
          disabled: !recordInfo || actionOnCourse,
          onClick: handleAccept,
          text: t('common.accept'),
        },
      ]}
      show={show}
      showCancel={false}
      showXButton={false}
      title={t('budget.actions.accept')}
      onHide={() => false}
    >
      <div>{t('budget.actions.acceptQuestion')}</div>
    </Modal>
  );
};
